import { SOURCE } from '@/config/events'

export default function useError() {
  function createErrorResponse(error) {
    // @TODO think about ending loading
    const extendedError = Object.assign(
      {
        status: error?.response?.status ?? 999,
        source: SOURCE.BACKEND,
        infoMessages: [],
      },
      error?.response?.data
    )

    return Promise.reject(extendedError)
  }

  return {
    createErrorResponse,
  }
}
